import { useOpenOmnichannelPurchaseModal } from "features/OmniChannel/modules/OmnichannelPlanModalWrapper/utils/useOpenOmnichannelPurchaseModal";
import { WHATSAPP_INTEGRATION_LOCK } from "features/Integration/modules/IntegrationCard/constants/whatsappIntegrationLock.constants";
import { useToggleState } from "utils/hooks";

export const useWhatsappLock = ({
  lockType,
  whitelabelModalOpen,
  onWhitelabelModalClose,
  onRequestOpenWhitelabelModal,
} = {}) => {
  const [internalOpen, openInternal, closeInternal] = useToggleState(false);
  const { openOmnichannelPurchaseModal } = useOpenOmnichannelPurchaseModal();

  const isControlled = whitelabelModalOpen !== undefined;
  const effectiveWhitelabelOpen = isControlled
    ? whitelabelModalOpen
    : internalOpen;
  const requestOpenWhitelabel = isControlled
    ? onRequestOpenWhitelabelModal
    : openInternal;
  const closeWhitelabelModal = isControlled
    ? onWhitelabelModalClose
    : closeInternal;

  const handleCloseWhitelabelModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (closeWhitelabelModal) {
      closeWhitelabelModal();
    }
  };

  const handleChipClick = (e) => {
    e.stopPropagation();
    if (lockType === WHATSAPP_INTEGRATION_LOCK.OMNICHANNEL) {
      openOmnichannelPurchaseModal(e);
      return;
    }
    if (requestOpenWhitelabel) {
      requestOpenWhitelabel();
    }
  };

  const mountWhitelabelUnlockModal =
    lockType !== WHATSAPP_INTEGRATION_LOCK.OMNICHANNEL;

  return {
    effectiveWhitelabelOpen,
    handleChipClick,
    handleCloseWhitelabelModal,
    mountWhitelabelUnlockModal,
  };
};
